export function formatPrice(
  price: number | string,
  options: Intl.NumberFormatOptions = {}
) {
  return formatNumber(price, {
    style: 'currency',
    currency: 'EUR',
    ...options,
  })
}
